// extracted by mini-css-extract-plugin
module.exports = {"container":"SummaryLineItem_container__2dkd9","largeText":"SummaryLineItem_largeText__1T9f6"};